/**
 * OG image paths resolved at build time from src/assets (jpg preferred, png fallback).
 */
const ogImageModules = import.meta.glob('../assets/images/*/og-image.{jpg,png}', {
  eager: true,
})

function hasOgImage(appId: string, ext: 'jpg' | 'png'): boolean {
  return Object.keys(ogImageModules).some((key) =>
    key.endsWith(`/images/${appId}/og-image.${ext}`)
  )
}

/**
 * Default OG image public path for an app (jpg preferred, png fallback).
 */
export function resolveOgImagePublicPath(appId: string): string {
  const base = `/assets/images/${appId}/og-image`
  if (hasOgImage(appId, 'jpg')) return `${base}.jpg`
  if (hasOgImage(appId, 'png')) return `${base}.png`
  return `${base}.png`
}

/**
 * If a configured path points at og-image.jpg but only png exists, return png.
 */
export function resolveOgImagePath(path: string, appId?: string): string {
  const match = path.match(/\/assets\/images\/([^/]+)\/og-image\.(jpg|png|svg)$/i)
  if (!match) return path

  const [, app, ext] = match
  if (ext.toLowerCase() !== 'jpg') return path

  return resolveOgImagePublicPath(appId ?? app)
}

export function getOgImageMimeType(imageUrl: string): string {
  if (/\.png(\?|$)/i.test(imageUrl)) return 'image/png'
  if (/\.jpe?g(\?|$)/i.test(imageUrl)) return 'image/jpeg'
  if (/\.svg(\?|$)/i.test(imageUrl)) return 'image/svg+xml'
  if (/\.webp(\?|$)/i.test(imageUrl)) return 'image/webp'
  return 'image/jpeg'
}
